var $formH = document.getElementById('product_form_7132689825969');
var variantsH = JSON.parse(decodeURIComponent($formH.getAttribute('data-variants')));
formOptions = {
        option1: null,
        option2: null,
        option3: null
      }
    if (variantsH != null) {
        variantsH.forEach(function (variant, index) {
          if (variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3) {
            selectedVariant = variant; //overide selectedVariant of null with the current variant object

            return false; //loop break
          }
          const variantOptionsInput = document.querySelectorAll('.styled-pills-radio > input');
          if (variant.name.includes('Beige') || variant.name.includes('Black')){
          variantOptionsInput.forEach(function (inp, i) { 
            
            if (inp.value === variant.option1) {
              if(variant.inventory_quantity == 0) {
               inp.classList.add("not-available");
            }
            else 
            {
              inp.classList.add("available");
            }
            }
             });
          }
        });
      }


